exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Dho4{font-family:Roboto\\, Medium}._3IGng{width:116px;height:116px;border-radius:100px;border:2px solid red;display:inline-block;position:relative;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2);box-shadow:0 1px 3px 0 rgba(0,0,0,.2);border-width:2px}._2HuBE{padding-bottom:72px}", ""]);

// exports
exports.locals = {
	"posicionText": "_1Dho4",
	"imgAvatar": "_3IGng",
	"datosMedico": "_2HuBE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalVideoLlamada/TimerModalVideoLlamada/TimerModalVideoLlamada.css
// module id = 1150
// module chunks = 0 1 2